import React from 'react';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import { cn } from '../../lib/cn';
import { Card } from './Card';
interface StatCardProps {
  label: string;
  value: string;
  delta?: {
    value: string;
    direction: 'up' | 'down';
    good?: boolean;
  };
  icon: React.ReactNode;
  accent?: string;
  footnote?: string;
}
export function StatCard({
  label,
  value,
  delta,
  icon,
  accent = 'text-brand-600 bg-brand-50',
  footnote
}: StatCardProps) {
  const isPositive = delta ? delta.good ?? delta.direction === 'up' : false;
  return <Card className="p-4" data-id="element-395" data-mp="3h3oh96or7m4v">
      <div className="flex items-start justify-between" data-id="element-396" data-mp="3h1u6umb3zcf1">
        <div className={cn('flex h-9 w-9 items-center justify-center rounded-lg', accent)} data-id="element-397" data-mp="3264em6fby31v">
          {icon}
        </div>
        {delta && <span className={cn('inline-flex items-center gap-0.5 text-xs font-semibold', isPositive ? 'text-emerald-600' : 'text-red-600')} data-id="element-398" data-mp="377tpnm2jygpy">
            {delta.direction === 'up' ? <TrendingUpIcon className="h-3.5 w-3.5" data-id="element-399" data-mp="1ytucs6jypmba" /> : <TrendingDownIcon className="h-3.5 w-3.5" data-id="element-400" data-mp="1tuhpxlt3cf8p" />}
            {delta.value}
          </span>}
      </div>
      <p className="mt-3 text-2xl font-bold font-display tracking-tight text-slate-900 tabular-nums" data-id="element-401" data-mp="27uiv3dge28tz">
        {value}
      </p>
      <p className="text-xs font-medium text-slate-500 mt-0.5" data-id="element-402" data-mp="22wqxq3wz5uie">{label}</p>
      {footnote && <p className="text-[11px] text-slate-400 mt-1.5" data-id="element-403" data-mp="2hq2nvqznorei">{footnote}</p>}
    </Card>;
}